<template>
  <div class="header" id="header">
    <div class="zhanwei"></div>
    <div class="hearone">
      <div class="tops main">
        <div class="topsleft">
          <div class="logo" @click="toindex">
            <img :src="Baseurl+logolist.wap_logo_path" alt="">
          </div>
          <div class="logotex">
            <p class="logotex1">{{logolist.web_name}}</p>
          </div>
        </div>
        <div class="topsright">
          <!-- <div class="yibiao" @click="toguan">
            汇中仪表官网
          </div> -->
          <div class="search">
            <div class="sousuo" @click="toSearch">
              <img src="../../assets/img/sousuo.png" alt="">
            </div>
            <div class="menu" @click="menuQie">
              <img v-if="menuShow" src="../../assets/img/menu.png" alt="">
              <img v-else src="../../assets/img/close.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="heartwo" v-if="!menuShow">
      <div class="nav main">
        <div class="navlist"  v-for="(item,index) in navlist" :key="index">
          <div class="navspan">
            <p  @click="topath(item.modul_id,item.id,index,item)">{{item.name}}</p>
            <img @click="meunOpen(index)" v-if="item.son.length>0" src="../../assets/img/jia.png" alt="">
          </div>
          <div class="listul" v-if="item.son.length>0&&menuOpenindex==index">
            <div class="listli" v-for="(itemMsg,indexMsg) in item.son" :key="indexMsg" @click.stop="topath(itemMsg.modul_id,itemMsg.id,index)">
              <img src="../../assets/img/sanjiao.png" alt="">
              <p>{{itemMsg.name}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="yuyan main">
        <p>Language：</p>
        <div class="yuset">
          <p class="active"  @click="yuyanchange('EN')">English</p>
          <p  @click="yuyanchange('CN')">中文</p>
        </div>
      </div>
    </div>

    <div class="fudong">
      <!-- <div class="fudlist">
        <img class="img1" src="../../assets/img/fd1.png" alt="">
        <img class="img2" src="../../assets/img/fdh1.png" alt="">
        <p>客服</p>
      </div> -->
      <div class="fudlist" @click="toTop">
        <img class="img1" src="../../assets/img/fd2.png" alt="">
        <img class="img2" src="../../assets/img/fdh2.png" alt="">
        <p>Top</p>
      </div>
    </div>
  </div>
</template>

<script>
import { set } from "vue";
// import Swiper from "swiper";
export default {
  components: {
  },
  data() {
    return {
      yuyanshow:false,
      navlist:[],//导航列表
      navIndex:0,//导航当前位置
      // searchtext:'',//搜索的关键词
      menuShow:true,
      menuOpenindex:99,
      logolist:[]
    };
  },
  created() {
    this.navIndex = localStorage.getItem("navIndex")
    this.getinfo()
  },
 
  inject: ["reload"],
  methods: {
    //切换语言
    yuyanchange(e) {
      var yuyan = e;
      var nowhref = window.location.href;
      if (yuyan == "CN") {
        var newhref = nowhref.replace("https://en", "https://www");
        console.log(newhref);
        // window.location.href = newhref;
        window.open(newhref)
      }else{
        this.reload()
      }
    },
    //菜单展开
    meunOpen(index){
      console.log(index)
      if(this.menuOpenindex==index){
        this.menuOpenindex=99
      }else{
        this.menuOpenindex = index
      }
      
    },
    //菜单展开与否
    menuQie(){
      this.menuShow = !this.menuShow
    },
    //获取头部信息
    getinfo(){
      var that = this;
      that.$axios
      .get(`${this.Baseurl}/public_header`) 
      .then(res => {
        console.log(res)
        that.navlist = res.data.data.Columns
        that.logolist =res.data.data.web_base
      }).catch(err => console.log(err));
    },
    //回到顶部
    toTop() {
      document.querySelector("#header").scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
    },
    //去首页
    toindex(){
      this.$router.push({name:'Index'})
    },
    // //去汇中仪表官网
    // toguan(){
    //   window.open("https://www.huizhong.co/home")
    // },
    // //选择语言弹窗的展示与否
    // yuyanset(){
    //   this.yuyanshow =!this.yuyanshow
    // },
    topath(mode,id,index,item){
      // if(index==this.navlist.length-1){
      //   this.$router.push({name:'Contact',query:{
      //   id:id,
      //   module_id:mode
      //   }})
      // }else if(index==0){
      //   this.$router.push({name:'Index'})
      // }else{
      //   //console.log(mode,id)
      //   this.$router.push({name:mode,query:{
      //     id:id,
      //     module_id:mode
      //   }})
      //   // if(index&&item.son.length>0){
      //   //   this.$router.push({name:mode,query:{
      //   //     id:item.son[0].id,
      //   //     module_id:item.son[0].mode
      //   //   }})
      //   // }else{
      //   //   this.$router.push({name:mode,query:{
      //   //     id:id,
      //   //     module_id:mode
      //   //   }})
      //   // }
      // }
      // console.log(mode)
      // console.log(id)
      // console.log(index)
      // console.log(item)
      console.log(index)
      if(index==0){
        this.$router.push({name:'Index'})
      }
      else if(index==1&&mode=="Gramlist"){
        this.$router.push({name:"Contact",query:{
          id:id,
          module_id:mode
        }})
      }else{
        this.$router.push({name:mode,query:{
          id:id,
          module_id:mode
        }})
      }
      // return false
      localStorage.setItem("navIndex",index)
      this.reload()
    },
    //去搜索页
    toSearch(){
      this.$router.push({name:'Search'})
      this.reload()
    },
  },
  mounted() {
    var that =this
    document.querySelector("#app").onclick=function(){
      that.yuyanshow = false
    }
  },
};
</script>
<style scoped>
  .fudong {
    position: fixed;
    right: 3vw;
    bottom: 40vw;
    z-index: 9999;
    width: 11.733vw;
    height: 20.267vw;
    background: #FFFFFF;
    border-radius: 6vw;
    /* box-shadow: 0px 0px 10px 1px #dcdcdc;  */
    box-shadow: 0px 0px 5px 1px #d1cccc;
    transform: scale(0.8);
  }

  .fudlist {
    margin-top: 3vw;
  }

  .fudlist>img {
    width: 7.200vw;
    height: 6.933vw;
    display: block;
    margin: auto;
  }

  .fudlist .img1 {
    display: block;
  }

  .fudlist .img2 {
    display: none;
  }

  .fudlist>p {
    font-size: 4vw;
    color: #434343;
    line-height: 9vw;
    text-align: center;
    margin: auto;
  }

  /* .nav{
    display: flex;
    height: 100%;
    align-items: center;
    padding-left: 30px;
  } */
  .navlist {
    position: relative;
    height: 100%;
    font-size: 4.2vw;
    color: #4c4c4c;
  }

  .navlist.active {
    color: #EE1D23;
  }

  .navlist .navspan {
    display: flex;
    align-items: center;
    /* height: 100%; */
    border-bottom: 0.133vw solid #d8d8d8;
    height: 13vw;
  }

  .navlist .navspan p {
    padding-left: 3vw;
  }

  .navlist .navspan img {
    width: 3.133vw;
    height: 3.133vw;
    display: block;
    margin-left: auto;
    margin-right: 3vw;
  }

  .listul {
    background-color: rgba(243, 243, 243, 0.85);
    width: 100%;
    top: 100%;
    left: 50%;
    z-index: 3;
    display: block;
    padding: 2vw 9.333vw;
    box-sizing: border-box;
  }

  .listul .listli {
    width: 100%;
    height: 10vw;
    line-height: 10vw;
    font-size: 3.8vw;
    color: #211814;
    display: flex;
    align-items: center;
  }
  .listul .listli  img{
    width:  0.800vw;
    height: 1.333vw;
    display: block;
    margin-right: 3.333vw;
  }

  .zhanwei {
    width: 100%;
    height: 13.333vw;
  }

  .hearone {
    width: 100%;
    height: 13.333vw;
    display: flex;
    align-items: center;
    position: fixed;
    z-index: 99;
    top: 0;
    background-color: #fff;
  }

  .tops {
    display: flex;
    align-items: center;
  }

  .topsleft {
    display: flex;
    align-items: center;
  }

  .topsleft .logo {
    width: 22.933vw;
    height: 6.267vw;
  }

  .topsleft .logo>img {
    width: 100%;
    height: 100%;
    display: block;
  }

  .topsleft .logotex {
    margin-left: 3.067vw;
    padding-left: 2.400vw;
    border-left: 0.133vw solid #929292;
    height: 6.267vw;
  }

  .topsleft .logotex .logotex1 {
    font-size: 3.5vw;
    font-weight: bold;
    color: #211814;
    width: 20vw;
    line-height: 3.5vw;
  }

  .topsright {
    margin-left: auto;
    display: flex;
    align-items: center;
  }

  .topsright .guanw {
    display: flex;
    align-items: center;
    width: 162px;
    height: 39px;
    background: #FFFFFF;
    border: 2px solid #D1211B;
    border-radius: 20px;
  }

  .topsright .guanw>p {
    font-size: 18px;
    color: #D1211B;
    margin-left: 15px;
  }

  .topsright .guanw>img {
    width: 20px;
    height: 14px;
    display: block;
    margin-left: 5px;
  }

  .yibiao {
    /* width: 171px;
    height: 39px; */
    width: 175px;
    height: 44px;
    background-image: url(../../assets/img/yibiao.png);
    background-size: 100% 100%;
    font-size: 18px;
    color: #D1211B;
    line-height: 44px;
    padding-left: 50px;
    font-weight: inherit;
    box-sizing: border-box;
  }

  /* .yibiao>img{
    width: 100%;
    height: 100%;
    display: block;
  } */
  .topsright .search {
    margin-left: auto;
    overflow: hidden;
    display: flex;
    box-sizing: border-box;
  }

  .topsright .search .sousuo {
    width: 4.667vw;
    height: 4.533vw;
  }

  .topsright .search .sousuo>img {
    width: 100%;
    height: 100%;
    display: block;
  }

  .topsright .search .menu {
    width: 4.667vw;
    height: 4.533vw;
    margin-left: 6vw;
  }

  .topsright .search .menu>img {
    width: 100%;
    height: 100%;
    display: block;
  }

  .yuyan {
    position: relative;
    display: flex;
    align-items: center;
    margin-top: 8.000vw;
    padding: 0 3vw;
    box-sizing: border-box;
  }
  .yuyan>p{
    font-size: 4.2vw;
    color: #4c4c4c;
  }
  .yuyan>.yuset{
    display: flex;
    align-items: center;
  }
  .yuyan>.yuset p{
    display: block;
    font-size: 4.2vw;
    color: #4c4c4c;
    margin-left: 6.667vw;
  }
  .yuyan>.yuset p.active{
    color: #ee1d23;
  }

  .heartwo {
    width: 100%;
    background-color: #fff;
    position: fixed;
    z-index: 98;
    top: 0;
    padding-top: 13.333vw;
    height: 100%;
    overflow-y: auto;
    padding-bottom: 10vw;
    box-sizing: border-box;
  }
</style>
